import * as $ from 'jquery';

export function activateTextmediaChevron(){
    $('.ce-textpic').find('.ce-bodytext').find('.crop.uncropped').hide();
    
    $('.ce-bodytext .icon-chevron-down').on('click', function(){
        const $helpdesk = $(this).parents('.ce-bodytext');
        $helpdesk.find('.crop').hide();
        $helpdesk.find('.crop.uncropped').show();
    })

    $('.ce-bodytext .icon-chevron-up').on('click', function(){
        const $helpdesk = $(this).parents('.ce-bodytext');
        $helpdesk.find('.crop').hide();
        $helpdesk.find('.crop.cropped').show();
    })
}